import React, { useContext } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import Badge from "react-bootstrap/Badge";
import Bin from "./common/Bin";
import UserContext from "../context/userContext";

const UsersTable = ({ data, onClick, length }) => {
  const [user] = useContext(UserContext);

  return (
    <table className="table table-hover">
      <caption style={{ captionSide: "top", paddingBottom: 0 }}>
        {length} User{length === 1 ? "" : "s"}
      </caption>
      <thead>
        <tr>
          <th>User</th>
          <th>Email Address</th>
          <th>Access {user.LONG_SITE}</th>
          <th>Last Updated</th>
          <th>Updated By</th>
          <th>Active</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {data.map((u) => (
          <tr key={u.USER_NAME}>
            <td>
              <Link to={`/users/${u.USERNAME}`}>
                {u.FULL_NAME ? u.FULL_NAME : u.USERNAME}
              </Link>
            </td>
            <td className="text-nowrap">{u.EMAIL}</td>
            <td className="text-nowrap">
              {u["ACCESS_" + user.SITE] ? (
                <Badge variant="success">True</Badge>
              ) : (
                <Badge variant="warning">false</Badge>
              )}
            </td>
            <td className="text-nowrap">
              {moment(u.LAST_UPDATED_DTS).utc().calendar()}
            </td>
            <td className="text-nowrap">{u.LAST_UPDATED_BY}</td>
            <td className="text-nowrap">
              {u.ACTIVE ? (
                <Badge variant="success">True</Badge>
              ) : (
                <Badge variant="warning">false</Badge>
              )}
            </td>
            <td>
              {u.ACTIVE ? (
                <Bin size="sm" onClick={() => onClick(u)} />
              ) : (
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => onClick(u)}
                >
                  Unarchive
                </button>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default UsersTable;
